import { useQuery } from "@tanstack/react-query";
import { OrderCustomFormTableQuery, OrderTableQuery } from "./models";
import { getTableQueryKey } from "../../helpers/tableHelpers";
import ordersClient from "../../api/private/ordersClient";
import documentsClient from "../../api/private/documentsClient";
import {
  CPCustomFormReportDocumentListResponse,
  CPOrderDetailQueryResult,
  TableResultCPOrder,
  TableResultCPOrderCustomForm,
} from "../../api/models/unified";

const ordersKey = "ordersKey";
const orderDocumentsKey = "orderDocumentsKey";
const orderDetailKey = "orderDetailKey";

export const getOrdersKeyBuilder = (customerId: string) => [
  ordersKey,
  customerId,
];

export const getOrderDetailKeyBuilder = (orderId: string) => [
  orderDetailKey,
  orderId,
];

export const getOrderDocumentsKeyBuilder = (orderId: string) => [
  orderDocumentsKey,
  orderId,
];

export const useGetOrdersQuery = (params: OrderTableQuery) => {
  return useQuery<TableResultCPOrder>({
    queryKey: getTableQueryKey(ordersKey, params),
    queryFn: () => ordersClient.getOrders(params),
  });
};

export const useGetOrderDetailQuery = (orderId?: string) => {
  return useQuery<CPOrderDetailQueryResult>({
    queryKey: getOrderDetailKeyBuilder(orderId ?? ""),
    queryFn: () => ordersClient.getOrderDetail(orderId ?? ""),
    enabled: !!orderId,
  });
};

export const useGetOrderCustomFormsQuery = (
  params: OrderCustomFormTableQuery,
) => {
  return useQuery<TableResultCPOrderCustomForm>({
    queryKey: getTableQueryKey(orderDocumentsKey, params),
    queryFn: () => ordersClient.getOrderCustomForms(params),
  });
};

export const useGetOrderDocumentsQuery = (orderId: string) => {
  return useQuery<CPCustomFormReportDocumentListResponse>({
    queryKey: getOrderDocumentsKeyBuilder(orderId),
    queryFn: () => documentsClient.getDocumentsByOrderId(orderId),
  });
};
